/* eslint-disable @next/next/no-img-element */
import { AptunoButton, Icon, SIZES, useResponsive, VARIANTS } from '@aptuno/aptuno-ui';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ActionsBarRoot, BigTitle, HeaderSection, ImageWrapper, TextNormal } from '../EstateApplication.styled';
import { CotenantRequiredWrapper, SecondaryBtn, ShareWrapper, SharingLink } from './CotenantRequired.styled';

export const CotenantRequired = ({ applicationId }) => {
  const router = useRouter();
  const baseLink = `${process.env.NEXT_PUBLIC_URL_APTUNO}/estate-application/add-cotenant?applicationId=`;
  const [linkToShare, setLinkToShare] = useState<string | undefined>(undefined);

  const waText = 'Hola!%20Estoy%20a%20punto%20de%20arrendar%20un%20inmueble%20con%20Aptuno%20y%20necesito%20que%20seas%20mi%20coarrendatario.%20Por%20favor%20completa%20el%20formulario%20en%20el%20siguiente%20link:';
  useEffect(() => {
    if (applicationId) {
      setLinkToShare(baseLink + applicationId);
    }
  }, [applicationId]);

  const { isMobile } = useResponsive();

  const getWhatsappLink = (): string => {
    return `https://wa.me/?text=${waText}%20${linkToShare}%20y%20seguir%20los%20pasos%20que%20se%20te%20indican.%20Gracias%20por%20confiar%20en%20Aptuno.`;
  };

  const handleOnClickShare = () => {
    window.open(getWhatsappLink(), '_blank');
  };

  const handleOnClickCopy = () => {
    setCopied(true);
  };
  const [copied, setCopied] = useState(false);

  const handleOnBackClick = () => {
    router.push('/perfil');
  };

  return (
    <CotenantRequiredWrapper isMobile={isMobile}>
      <HeaderSection horizontalAlign="center" verticalAlign="center" padding={'0'}>
        <ImageWrapper
          height={isMobile ? '214px' : '293px'}
          width={isMobile ? '276px' : '390px'}
          margin={`32px 0 48px 0`}
        >
          <img src={`/images/cotenants.svg`} alt="cotenant required" />
        </ImageWrapper>
        <BigTitle>Necesitas a otra persona para aplicar.</BigTitle>
        <TextNormal align="center">
          Envíale el siguiente enlace a tu coarrendatario, espera a que aplique desde su cuenta y te enviaremos tu
          resultado:
        </TextNormal>
        <ShareWrapper>
          <SharingLink>
            <p>{linkToShare}</p>{' '}
            <CopyToClipboard text={linkToShare} onCopy={() => setCopied(true)} onClick={() => {}}>
              <Icon
                icon={copied ? 'circle-check' : 'copy'}
                color={copied ? '#3CD278' : '#000000'}
                onClick={handleOnClickCopy}
              />
            </CopyToClipboard>
          </SharingLink>
          {copied && <span>Enlace copiado!</span>}
        </ShareWrapper>
      </HeaderSection>
      <ActionsBarRoot>
        <SecondaryBtn appearance={VARIANTS.SECONDARY} size={SIZES.SMALL} onClick={handleOnBackClick} isMobile={isMobile}>
          Ir a aptuno
        </SecondaryBtn>
        <AptunoButton appearance={VARIANTS.PRIMARY} size={SIZES.BIGGEST} onClick={handleOnClickShare}>
          Compartir enlace <Icon icon="Share" />
        </AptunoButton>
      </ActionsBarRoot>
    </CotenantRequiredWrapper>
  );
};
